module.exports = __webpack_public_path__ + "img/BizOpsAPPLogo.871bfce7.svg";